/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url("../shared.css");

:host {
  display: inline-block;
}

.qds-title-link-heading {
  margin-block: 0;
}

.qds-title-link {
  height: var(--qds-control-standard-height);
  display: flex;
  align-items: center;
  color: var(--qds-theme-link-subdued-default);
}

a {
  gap: var(--qds-text-icon-gap);
  text-decoration: none;
  color: var(--qds-theme-link-subdued-default);
  text-decoration-color: var(--qds-theme-link-subdued-default);
}

a:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
  outline-offset: var(--qds-focus-border-offset);
}

a:disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

a:hover {
  cursor: pointer;
  text-decoration: underline;
  color: var(--qds-theme-link-subdued-hover);
}

a:active {
  color: var(--qds-theme-link-subdued-pressed);
}

p {
  font: var(--qds-control-standard-text);
  font-weight: bold;
  text-wrap: wrap;
  margin: 0;
}

qds-icon {
  flex-shrink: 0;
  transform: scaleX(var(--qds-direction-factor));
  height: var(--qds-control-standard-icon-size);
  width: var(--qds-control-standard-icon-size);
}

[aria-disabled="true"] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

[data-size="small"] {
  &.qds-title-link {
    height: var(--qds-control-small-height);
  }

  p {
    font: var(--qds-control-small-text);
    font-weight: bold;
  }

  qds-icon {
    height: var(--qds-control-small-icon-size);
    width: var(--qds-control-small-icon-size);
  }
}

[data-size="large"] {
  &.qds-title-link {
    height: var(--qds-control-large-height);
  }

  p {
    font: var(--qds-navigation-section-title-emphasized);
  }

  qds-icon {
    height: var(--qds-control-large-icon-size);
    width: var(--qds-control-large-icon-size);
  }
}

.qds-icon-wrapper {
  display: flex;
  align-items: center;
}
